import type { PermissionData } from '../types'

export function computeDispatchToDriverPermission(permissionData: PermissionData) {
  if (permissionData.rmOnly) return 'hidden'

  return 'enabled'
}
